import { Injectable } from "@angular/core";
import { DwModalConfig, DwModalButtonStandardConfigs, DwModalSize, DwActionResult, DwModalService, DwEventService, DwOrmDataService } from "@devwareapps/devware-cap";

import { SchoolSelectionModalComponent } from "../../admin/components/school-selection-modal/school-selection-modal.component";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { PurchaseCourseModalComponent } from "../components/purchase-course-modal/purchase-course-modal.component";
import { PurchaseCourseModalConfig } from "../models/purchase-course-modal-config.model";
import { AppMetaDataItemNames } from "../../../meta-data/app-meta-data.service";
import { GamificationRepositoryService } from "../../gamification/services/gamification-repository.service";

export const COURSE_PURCHASED_EVENT = 'aviator-online-course-purchased';

@Injectable({
    providedIn: 'root'
    })
export class PaymentPurchaseService {

    constructor(
        private dwModalService: DwModalService,
        private dwEventService: DwEventService,
        private gamificationRepositoryService: GamificationRepositoryService
    ) { }

    showPurchaseCourseModal(purchaseCourseConfig: PurchaseCourseModalConfig): Observable<DwActionResult> {
        let modalConfig = new DwModalConfig<PurchaseCourseModalConfig>();

        // The redesigned modal renders its own title, close affordance and
        // "Pay" button inside the body (see PurchaseCourseModalComponent), so
        // the framework chrome is suppressed: the footer here, and the header
        // via scoped CSS in styles/features/purchase-course-modal.scss.
        modalConfig.buttons = [DwModalButtonStandardConfigs.instance.okButton];
        modalConfig.buttons[0].buttonText = 'Purchase';
        modalConfig.hideFooter = true;

        modalConfig.allowFullScreen = false;
        modalConfig.modalSize = DwModalSize.responsive;

        modalConfig.component = PurchaseCourseModalComponent;

        modalConfig.data = purchaseCourseConfig;
        modalConfig.title = 'Purchase Course';


        return this.dwModalService.showModal<any,any>(modalConfig)
            .pipe(map(modalResult => {
                const result = new DwActionResult();

                if (modalResult.cancelled) {
                    result.cancelled = true;

                    return result;
                }

                this.gamificationRepositoryService.invalidate();
                this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.StudentCourse), {});
                this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.Course), {});
                this.dwEventService.publishEvent(COURSE_PURCHASED_EVENT, {});

                result.success = true;
                result.message = 'Course Purchased successfully';

                return result;
            }));
    }
}
